import { render } from "./AddVirement.vue?vue&type=template&id=491f20aa&ts=true"
import script from "./AddVirement.vue?vue&type=script&lang=ts"
export * from "./AddVirement.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__